import { Typography } from 'antd';
import { ReactNode } from 'react';
import styles from './listTile.module.css';

type ListTileType = {
  icon: ReactNode;
  title: string;
  subtitle: ReactNode;
  actionIcon?: ReactNode;
  actionTitle?: string;
  actionDescription?: string;
  color: 'white' | 'black';
  variant: 'primary' | 'secondary';
};
const ListTile = ({
  actionIcon,
  icon,
  subtitle,
  title,
  actionTitle,
  actionDescription = '',
  color = 'white',
  variant = 'primary',
}: ListTileType) => {
  const { Text } = Typography;
  return (
    <div className={`${styles.tileLayout} ${styles.variant}`}>
      <div>{icon}</div>
      <div className={`${styles.conentLayout} ${styles[color]}`}>
        <Text
          className={`${styles.title} ${styles[color]} ${styles[variant + 'Title']}`}
        >
          {title}
        </Text>
        <Text
          className={`${styles.subtitle} ${styles[color]} ${styles[variant + 'Subtitle']}`}
        >
          {subtitle}
        </Text>
      </div>
      <div className={styles.actionContentContainer}>
        {actionTitle && (
          <div
            className={`${styles.conentLayout} ${styles.rightContentLayout} ${styles[color]}`}
          >
            <Text
              className={`${styles.title} ${styles[color]} ${styles[variant + 'Title']}`}
            >
              {actionTitle}
            </Text>
            <Text
              className={` ${styles[color]} ${styles[variant + 'Subtitle']}`}
            >
              {actionDescription}
            </Text>
          </div>
        )}
        {actionIcon}
      </div>
    </div>
  );
};

export default ListTile;
